import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApiProvider } from "@src/store/ApiProvider";
import axios from "axios";
import { withPasswordManagerRefresh } from "./passwordManagerRequest";

interface IDeleteNotificationEmailParams {
	credentialId: number;
}

interface IDeleteNotificationEmailState {
	loading: boolean;
	error: string | null;
}

const initialState: IDeleteNotificationEmailState = {
	loading: false,
	error: null,
};

const getAuthHeaders = () => {
	const token = localStorage.getItem("PasswordManager_accessToken") ?? "";
	return {
		Authorization: token ? `Bearer ${token}` : undefined,
		passwordManagerAccessToken: token || undefined,
	};
};

const buildUrl = (credentialId: number) => {
	const baseUrl = ApiProvider.default.passwordManagerBaseURL || "https://qa.stagefront.com/password-manager/api";
	return `${baseUrl.replace(/\/$/, "")}/Credentials/DeleteNotificationMail?credentialId=${credentialId}`;
};

export const deleteNotificationEmail = createAsyncThunk<undefined, IDeleteNotificationEmailParams>(
	"passwordManager/deleteNotificationEmail",
	async ({ credentialId }, { rejectWithValue, dispatch }) => {
		try {
			await withPasswordManagerRefresh(dispatch, () => axios.delete(buildUrl(credentialId), { headers: getAuthHeaders() }));
			return undefined;
		} catch (error: unknown) {
			return rejectWithValue(error instanceof Error ? error.message : "Failed to delete notification email");
		}
	},
);

const deleteNotificationEmailSlice = createSlice({
	name: "passwordManager/deleteNotificationEmail",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(deleteNotificationEmail.pending, (state) => {
				state.loading = true;
				state.error = null;
			})
			.addCase(deleteNotificationEmail.fulfilled, (state) => {
				state.loading = false;
				state.error = null;
			})
			.addCase(deleteNotificationEmail.rejected, (state, action) => {
				state.loading = false;
				state.error = (action.payload as string) || action.error.message || "Failed to delete notification email";
			});
	},
});

export const deleteNotificationEmailReducer = deleteNotificationEmailSlice.reducer;
